"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "getKey", {
  enumerable: true,
  get: function get() {
    return _helper.getKey;
  }
});
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _CircuitBreaker = _interopRequireDefault(require("./CircuitBreaker"));
var _helper = require("./helper");
/**
 * Generate axios interceptor for circuit breaker
 */
var BreakerManager = exports["default"] = /*#__PURE__*/function () {
  /**
   * Constructor the docs circuit breaker
   */
  function BreakerManager(options, logger) {
    (0, _classCallCheck2["default"])(this, BreakerManager);
    this.breakerMap = new Map();
    this.options = options;
    this.logger = logger;
  }

  /**
   * Get breaker instance for specific config
   */
  return (0, _createClass2["default"])(BreakerManager, [{
    key: "getInstance",
    value: function getInstance(config) {
      var key = (0, _helper.getKey)(config, this.options);
      if (!key) return undefined;
      if (!this.breakerMap.has(key)) {
        var instance = new _CircuitBreaker["default"](this.options, this.logger, key);
        this.breakerMap.set(key, instance);
        if (this.logger) this.logger.info("[Circuit Breaker][RPM ".concat(instance.getRPM(config), "] Created for ").concat(key));
      }
      return this.breakerMap.get(key);
    }

    /**
     * Http request interceptor
     */
  }, {
    key: "requestInterceptor",
    value: function requestInterceptor() {
      var _this = this;
      return {
        fulfilled: function () {
          var _fulfilled = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(config) {
            var breaker;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  breaker = _this.getInstance(config);
                  if (breaker) breaker.processStart(config);
                  return _context.abrupt("return", config);
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function fulfilled(_x) {
            return _fulfilled.apply(this, arguments);
          }
          return fulfilled;
        }(),
        rejected: function () {
          var _rejected = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(error) {
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  throw error;
                case 1:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function rejected(_x2) {
            return _rejected.apply(this, arguments);
          }
          return rejected;
        }()
      };
    }

    /**
     * Http response interceptor
     */
  }, {
    key: "responseInterceptor",
    value: function responseInterceptor() {
      var _this2 = this;
      return {
        fulfilled: function () {
          var _fulfilled2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(response) {
            var breaker;
            return _regenerator["default"].wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  breaker = _this2.getInstance(response.config);
                  if (breaker) breaker.processEnd();
                  return _context3.abrupt("return", response);
                case 3:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function fulfilled(_x3) {
            return _fulfilled2.apply(this, arguments);
          }
          return fulfilled;
        }(),
        rejected: function () {
          var _rejected2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(error) {
            var config, breaker;
            return _regenerator["default"].wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  if (error.response) {
                    // Check `error.response` based on https://github.com/axios/axios?tab=readme-ov-file#handling-errors
                    // The request was made and the server responded with a status code that falls out of the range of 2xx
                    config = error.response.config || error.config || {}; // Usually, the two `config` are the same object.
                    breaker = _this2.getInstance(config);
                    if (breaker) breaker.processError({
                      status: error.response.status,
                      headers: Object.assign({}, config.headers, error.response.headers)
                    });
                  }
                  throw error;
                case 2:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          function rejected(_x4) {
            return _rejected2.apply(this, arguments);
          }
          return rejected;
        }()
      };
    }
  }]);
}();